// Shared mobile-vs-desktop viewport predicate for the /7 ↔ /7/m route split.
// Used by the route guard (App.tsx) and both preview layouts — keep them on the
// same predicate or they redirect-loop against each other.

const MOBILE_BREAKPOINT = 520;

// Foldables report a wider CSS viewport than phones while still being handheld
// touch devices: Galaxy Z Fold inner ≈ 673px, Pixel Fold ≈ 701px, Surface Duo
// 540px. Route them to the mobile view too, but stop short of tablet widths
// (iPad mini portrait = 744px) so tablets keep the desktop view.
const TOUCH_MOBILE_BREAKPOINT = 720;

export function isMobileViewport(): boolean {
  if (typeof window === 'undefined') return false;
  const w = window.innerWidth;
  if (w <= MOBILE_BREAKPOINT) return true;
  if (w > TOUCH_MOBILE_BREAKPOINT) return false;
  // 520–720px: mobile only for touch-only devices — a desktop browser window
  // narrowed into this range (hover-capable) stays on the desktop view.
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}
